import type { ApiPlayable } from "@hive/sdk";

/**
 * Muhaha content is a polymorphic Hive `Playable`; its `kind` selects the
 * experience — `game` (H5 playable) or `drama` (interactive short video). This
 * mirrors the native muhaha-app so both clients read the same catalog.
 */
export type PlayableKind = "game" | "drama";

/** Content-type filter chips (in display order). */
export const PLAYABLE_KINDS: PlayableKind[] = ["game", "drama"];

/**
 * Resolve a playable's content kind. Prefers the explicit `kind` field and
 * falls back to `game` for legacy/seeded items with no (or an unknown) kind, so
 * they still open in the player instead of dead-ending. Drama is only ever set
 * explicitly.
 */
export function playableKind(item: Pick<ApiPlayable, "kind">): PlayableKind {
	const kind = (item.kind || "").toLowerCase();
	if (kind === "drama") return "drama";
	return "game";
}

/** In-app route for opening a playable, by kind. */
export function playablePath(item: Pick<ApiPlayable, "id" | "kind">): string {
	switch (playableKind(item)) {
		case "drama":
			return `/drama/${item.id}`;
		default:
			return `/play/${item.id}`;
	}
}

/** i18n key for a content-type label (nav chips + card badge). */
export function kindLabelKey(kind: PlayableKind): `contentType.${PlayableKind}` {
	return `contentType.${kind}`;
}
